var router =require('pjax').Router;
var accountForm = require('./form.js');
var accountIndex = require('./index.js');

router.get('account/new', accountForm);
router.get('account', accountIndex);
